// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3149":"5ccc6877","3958":"b6eb7922","7145":"5ccc6877","9794":"5d0a4f52"}[chunkId] + ".chunk.css";
};